import { IXmlNode } from '@/app-modules/server-communications';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';
import { PrizeWinnerData } from '@/components/game/_domain/server/prize-winner/prize-winner-data';
import { PiratesPrizeType, getPrizeTypeName } from '@/components/game/implementations/uk/pirates/_domain/models';

class PiratesPrizeWinner extends PrizeWinnerData {
    constructor(node: IXmlNode) {
        super(node);
    }

    protected getStages(): DefaultStageElement[] {
        return [
            { name: getPrizeTypeName(PiratesPrizeType.OneLine), stage: 1 },
            { name: getPrizeTypeName(PiratesPrizeType.FullHouse), stage: 2 },
            { name: getPrizeTypeName(PiratesPrizeType.Jackpot), stage: 3 }
        ];
    }
}

export { PiratesPrizeWinner };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/pirates/_domain/models/prize-winner.ts